import * as React from 'react';
import { State as MyType } from '@shapeable/types';
import { EntityCard, EntityConfig, EntityDetailsLayout, entityStandardFormFields, graphql } from '@shapeable/core';
// import { ExamAttemptDetailsLayout } from '../components/exam-attempt-details-layout';

export const ExamAttempt: EntityConfig<MyType> = {
  name: 'ExamAttempt',
  autoRoutes: ['list', 'create', 'update'],
  update: {
    queryFields: `status`,
  },
  // components: {
  //   details: ExamAttemptDetailsLayout,
  //   card: EntityCard
  // },
  form: {
    fields: {
      ...entityStandardFormFields,
      status: {
        type: 'select',
        label: 'Status',
        description: 'Select the status of the exam attempt.',
        options: [
          { label: 'Passed', value: 'passed' },
          { label: 'Failed', value: 'failed' },
        ],
      },
      answersJson: { type: 'longText', description: "Store quiz answers as JSON for flexibility. The structure of this JSON can be defined by the client application, but should include enough information to determine which questions were answered and whether they were correct." },
    },
  },
};
